import { adminGet } from '../../api/adminCall';

export async function fetchTransactions({ pageSize = 25, cursor = null } = {}) {
  const params = new URLSearchParams();
  params.set('limit', String(pageSize));
  const afterId = cursor?.id || cursor;
  if (afterId) params.set('afterId', String(afterId));
  const data = await adminGet(`/api/admin/payments/transactions?${params.toString()}`);
  const items = (data?.items || []).map((item) => ({
    ...item,
    createdAt: item.createdAtMs ? new Date(item.createdAtMs) : item.createdAt ? new Date(item.createdAt) : null,
  }));
  return { items, cursor: data?.cursor || null };
}

export async function getTransactionById(id) {
  if (!id) return null;
  return null;
}
